<template>
  <div>
    <div class="intro-survey" v-if="intro && !loading">
      <div class="row intro col-at-sm" v-if="!error">
        <div class="card card--white intro-card small-top" style="flex: 1">
          <h1>{{ assessment.name }}</h1>
          <div class="card card--container">
            <div>
              {{ assessment.description }}
            </div>
            <h-input label="Promo Code" v-model="token" v-if="coachAssessment.promo_required" />
            <div v-if="errorMessage" class="error-msg">
              {{errorMessage}}
            </div>
            <div v-if="!user.id">
              <v-checkbox v-model="tos"><a slot="label" :href="tosUrl">I agree to terms of service</a></v-checkbox>
              <button class="btn btn--primary full-width" :disabled="!tos" @click="takeSurvey">Start</button>
            </div>
            <button class="btn btn--primary full-width" v-else @click="takeSurvey">Start</button>
          </div>
        </div>
      </div>
      <div class="card card--white" v-else >
        <div class="card card--container">
          <h3>Error: 404</h3>
          <div>This assessment is no longer active</div>
        </div>
      </div>
    </div>
    <survey v-else class="fade-in" :questions="assessment.questions" @finished="finish" :instructions="assessment.instructions"></survey>
    <user-info-modal v-if="displayUserInfo" @save="saveAssessment" :error="userError" />
    <loading-modal v-if="displayLoading" />
  </div>
</template>

<script>
import coachingPitch from "@/components/coachingPitch";
import survey from "./survey";
import store from "@/services/api/store";
import userInfoModal from "./userInfoModal";
import loadingModal from "./loadingModal";
import AuthUser from "@/services/api/authUser";
import gql from "graphql-tag";

const ASSESSMENT_STORE = "Assessments";
const LEAD_ASSESSMENTS_STORE = "LeadAssessments";

export default {
  components: {
    coachingPitch,
    survey,
    userInfoModal,
    loadingModal
  },
  props: ["id"],
  data() {
    return {
      assessment: { name: "", questions: [] },
      tos: false,
      tosUrl: process.env.VUE_APP_API_HOST + "/terms-of-service",
      intro: true,
      displayUserInfo: false,
      displayLoading: false,
      user: AuthUser,
      error: false,
      errorMessage: "",
      loading: false,
      userError: "",
      token: "",
      coachAssessment: {}
    }
  },
  created() {
    this.loadig = true;
    store
      .find(ASSESSMENT_STORE, this.id)
      .then(coachCreatedAssessment => {
        this.coachAssessment = coachCreatedAssessment;
        this.assessment = coachCreatedAssessment.assessment;
      })
      .catch(() => {
        this.error = true;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    takeSurvey() {
      this.error = false;
      this.errorMessage = "";
      if (this.codeRequired) {
        if (!this.token) {
          this.errorMessage = "A Code is required to take this assessment"
          return
        }
        this.$apollo.query({
          query: gql`
          query isTokenValid($token: String!) {
            isTokenValid(token: $token)
          }`,
          variables: {
            token: this.token
          }
        }).then(({data})=> {
          if (data.isTokenValid) {
            this.intro = false;
            window.scrollTo(0, 0);
          } else {
            this.errorMessage = "This token is no longer valid";
          }
        })
        return
      }
      this.intro = false;
      window.scrollTo(0, 0);
    },
    finish() {
      if (AuthUser.id) {
        this.saveAssessment({user: AuthUser.id});
      } else {
        this.displayUserInfo = true;
      }
    },
    saveAssessment(user) {
      this.displayUserInfo = false;
      this.displayLoading = true;
      const assessment = {
        assessment: this.assessment.id,
        code: this.token,
        coach_assessment: this.coachAssessment.id,
        answers: this.assessment.questions.map(q => ({
          question: q.id,
          answer: q.answer
        })),
        ...user
      };
      store.create(LEAD_ASSESSMENTS_STORE, assessment).then(a => {
        this.$router.push("/assessments/results/" + a.uuid);
      }).catch(e => {
        console.log(e)
      })
    }
  },
  computed: {
    disabled() {
      return !(this.email && this.tos);
    },
    codeRequired() {
      return this.coachAssessment.promo_required
    }
  }
};
</script>

<style lang="less" scoped>
.intro-survey {
  height: 80vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 640px) {
   height: 100%; 
  }

  .intro {
    height: auto;
    max-width: 850px;
    margin: 0px auto;
    .intro-card {
      max-height: 400px;
    }
  }
  h3 {
    font-size: 24px;
    font-weight: 300;
    color: #70a4ff;
  }
}
</style>
